export class LocalStorage {
    private static instance: LocalStorage

    static getInstance() {
        return this.instance || (this.instance = new this())
    }

    clear(key: string) {
        localStorage.removeItem(key)
    }

    get<T>(key: string): T | undefined {
        const json = localStorage.getItem(key)
        if (!json) {
            throw new Error(`The key '${key}' does not exist.`)
        }

        return JSON.parse(json) as T
    }

    getOrDefault<T>(key: string, value: string | undefined): T | undefined {
        const json = localStorage.getItem(key)
        if (!json) {
            if (value !== undefined) {
                return value as T
            }

            return undefined
        }

        return JSON.parse(json) as T
    }

    set<T>(key: string, value: T) {
        localStorage.setItem(key, JSON.stringify(value))

    }
}

export default LocalStorage

export const LOCAL_STORAGE = LocalStorage.getInstance()
